/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Knp_Manager_Terms_TabInputs */



/**
* | output |
* | --- |
* | "Terms ({count})" |
*
* @param {Knp_Manager_Terms_TabInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_terms_tab = /** @type {((inputs: Knp_Manager_Terms_TabInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_Terms_TabInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Termes (${i?.count})`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Begriffe (${i?.count})`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Termini (${i?.count})`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Термины (${i?.count})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Términos (${i?.count})`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`条款（${i?.count}）`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`利用規約 (${i?.count})`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`शर्तें (${i?.count})`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Termos (${i?.count})`)
	return /** @type {LocalizedString} */ (`Terms (${i?.count})`)
});